module.exports = __webpack_public_path__ + "static/media/thing.9dafac6d.png";